import styles from './ProfileAvatar.module.scss'

const ProfileAvatar = ({ src, isExpanded, onToggle }) => {
  return (
    <div className={styles.info_heading}>
      <div className={styles.avatar}>
        <div className={styles.avatar_img}>
          <img
            src={src}
            alt="avatar"
            onClick={onToggle}
            style={{ cursor: 'pointer' }}
          />
        </div>
        {isExpanded && (
          <div className={styles.avatar_img2} onClick={onToggle}>
            <img
              src={src}
              alt="Expanded Avatar"
              style={{
                cursor: 'pointer',
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 9999,
                maxWidth: '380px',
                maxHeight: '380px',
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default ProfileAvatar
